/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.bg-striped[_ngcontent-%COMP%]{\n    margin: 0;\n    height: 45px !important;\n    background-color: gray;\n    border-radius: 0 !important;\n    background-image: repeating-linear-gradient(-45deg, transparent, transparent 25px, rgba(255,255,255,.5) 25px, rgba(255,255,255,.5) 45px);\n}\n\n.progress-bar-cloud[_ngcontent-%COMP%]{\n    height: 45px !important;\n    background-color: #000000 !important;\n    opacity: 0.7;\n    border-radius: 0 !important;\n    line-height: 45px !important;\n}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL2NvbXBvbmVudHMvcHJvZ3Jlc3NiYXIvcHJvZ3Jlc3NiYXIuY29tcG9uZW50LmNzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9zcmMvdWkvc3JjL2FwcC9jb21wb25lbnRzL3Byb2dyZXNzYmFyL3Byb2dyZXNzYmFyLmNvbXBvbmVudC5jc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./aot_output/src/app/components/progressbar/progressbar.component.css.shim.ngstyle.ts